import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";

const cache: Record<string, string> = {};

export function SourceImage({ sourceId, className, alt = "", testid }: { sourceId: string; className?: string; alt?: string; testid?: string }) {
  const api = useApi();
  const [url, setUrl] = useState<string>(cache[sourceId] || "");
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!sourceId || cache[sourceId]) return;
    let alive = true;
    api.get(`/sources/${sourceId}/file`, { responseType: "blob" })
      .then((r) => { cache[sourceId] = URL.createObjectURL(r.data); if (alive) setUrl(cache[sourceId]); })
      .catch(() => alive && setFailed(true));
    return () => { alive = false; };
  }, [api, sourceId]);
  if (failed) return null;
  if (!url) return <div className={`${className} bg-[var(--bg-surface-hover)] animate-pulse`} />;
  return <img src={url} alt={alt} className={`${className} object-cover`} data-testid={testid} />;
}
